import { render, staticRenderFns } from "./OneTopWarehouses.vue?vue&type=template&id=00c0f1fc&scoped=true&lang=pug&"
import script from "./OneTopWarehouses.vue?vue&type=script&lang=ts&"
export * from "./OneTopWarehouses.vue?vue&type=script&lang=ts&"
import style0 from "./OneTopWarehouses.vue?vue&type=style&index=0&id=00c0f1fc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.9.8_vd7qwssw5i3h3fjzjs5bz4d2ha/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00c0f1fc",
  null
  
)

export default component.exports